module.exports = __webpack_public_path__ + "static/media/google-play@3x.2bdb3138.png";